import { FC } from 'react';
import styles from './styles.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faXmark } from '@fortawesome/free-solid-svg-icons';
import TextLink from '../../TextLink';

export type SucceededProps = {
  onClose: () => void;
  onConfirm?: () => void;
};
const Succeeded: FC<SucceededProps> = ({ onClose, onConfirm }) => {
  return (
    <div className={styles.container}>
      <div className={styles.textContainer}>
        <FontAwesomeIcon icon={faCheck} className={styles.icCheck} />
        <span className={styles.controlText}>計算が完了しました</span>
      </div>
      <div>
        <TextLink to="/allocations" onClick={onConfirm}>
          配車表を見る
        </TextLink>
        <button
          className={styles.closeButton}
          onClick={() => {
            onClose();
            onConfirm && onConfirm();
          }}
        >
          <FontAwesomeIcon icon={faXmark} />
        </button>
      </div>
    </div>
  );
};

export default Succeeded;
